// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Side bar */
/* Add shadows into the element */
/* Container with a column direction */
.row-layout {
  display: flex;
  flex-direction: row;
  height: 100%;
}

/* Container with a column direction */
.column-layout {
  display: flex;
  flex-direction: column;
  width: 100%;
}

/* Item style for empty lists */
.notification-label {
  display: flex;
  justify-content: center;
  padding: 1rem;
  gap: 8px;
}

:host {
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  flex-grow: 0;
  width: 400px;
  box-shadow: 0 8px 12px 1px rgba(29, 17, 51, 0.04), 0 3px 16px 2px rgba(9, 32, 77, 0.12), 0 5px 10px -3px rgba(29, 17, 51, 0.12);
  z-index: 20;
}

ion-searchbar,
ion-progress-bar {
  background-color: var(--ion-background-color);
}

cdk-tree ion-item {
  display: flex;
  font-size: var(--font-size-small);
}
cdk-tree ion-item:not(.checkbox-item) {
  flex: 1;
}

ion-item.checkbox-item {
  width: auto;
  --min-height: unset;
  --inner-padding-end: 0;
  --inner-padding-start: 0;
  --padding-start: 0;
  --padding-end: 0;
}

.leaf-wrapper {
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
  width: 100%;
}
.leaf-wrapper ion-checkbox {
  flex-shrink: 0;
}
.leaf-wrapper ion-item[button] {
  flex: 1;
  min-width: 0;
}

.region-searchbar {
  font-size: var(--font-size-medium);
}

/** Media queries to set font size and spacing based on screen size **/
/*#region Small Screens*/
/* Styles for screens smaller than 800px wide or 550 high */
@media (max-width: 800px) or (max-height: 550px) {
  .tree-icon {
    margin-right: 5px;
  }
}
/*#endregion Small Screens*/
/*#region Medium Screens*/
/* Styles for medium screens with min with of 800px and min height of 550px */
@media (min-width: 800px) and (min-height: 550px) {
  .tree-icon {
    margin-right: 10px;
  }
}
/*#endregion Medium Screens*/
/*#region Larger Screens*/
/* Styles for screens larger than 1000px wide and 600px high */
/*#endregion Larger Screens*/`, "",{"version":3,"sources":["webpack://./src/custom-style.scss","webpack://./src/app/pages/region-maps-page/components/region-side/region-side.component.scss"],"names":[],"mappings":"AAIA,aAAA;AAiBA,iCAAA;AAOA,sCAAA;AACA;EACI,aAAA;EACA,mBAAA;EACA,YAAA;ACzBJ;;AD4BA,sCAAA;AACA;EACI,aAAA;EACA,sBAAA;EACA,WAAA;ACzBJ;;AD4BA,+BAAA;AACA;EACI,aAAA;EACA,uBAAA;EACA,aAAA;EACA,QAAA;ACzBJ;;AApBA;EDII,aAAA;EACA,sBAAA;EACA,cAAA;EACA,YAAA;EACA,YAL8B;EAkB9B,+HAAA;EAEA,WAH6B;ACUjC;;AAzBA;;EAEI,6CAAA;AA4BJ;;AAxBI;EACI,aAAA;EAMA,iCAAA;AAsBR;AA1BQ;EACI,OAAA;AA4BZ;;AApBA;EACI,WAAA;EACF,mBAAA;EACA,sBAAA;EACA,wBAAA;EACA,kBAAA;EACA,gBAAA;AAuBF;;AApBA;EACI,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,WAAA;AAuBJ;AArBI;EACI,cAAA;AAuBR;AApBI;EACI,OAAA;EACA,YAAA;AAsBR;;AAjBA;EACI,kCAAA;AAoBJ;;AAjBA,sEAAA;AAEA,wBAAA;AAEE,2DAAA;AACA;EAEE;IACI,iBAAA;EAiBN;AACF;AAdA,2BAAA;AAEA,yBAAA;AAEE,6EAAA;AACA;EACE;IACI,kBAAA;EAcN;AACF;AAVA,4BAAA;AAEA,yBAAA;AAEE,8DAAA;AAKF,4BAAA","sourcesContent":["\r\n\r\n// About @use https://stackoverflow.com/questions/66365150/when-importing-a-file-with-use-then-error-undefined-mixin/66366316#66366316\r\n\r\n/* Side bar */\r\n@mixin side-component($width-val: 400px) {\r\n    display: flex;\r\n    flex-direction: column;\r\n    flex-shrink: 0;\r\n    flex-grow: 0;\r\n    width: $width-val;\r\n}\r\n\r\n@mixin main-component($width-val: 1200px) {\r\n    display: flex;\r\n    flex-direction: column;\r\n    flex-shrink: 0;\r\n    flex-grow: 0;\r\n    width: $width-val;\r\n}\r\n\r\n/* Add shadows into the element */\r\n@mixin with-shadow($z-index-val: 20) {\r\n    box-shadow: 0 8px 12px 1px rgb(29 17 51 / 4%), 0 3px 16px 2px rgb(9 32 77 / 12%),\r\n        0 5px 10px -3px rgb(29 17 51 / 12%);\r\n    z-index: $z-index-val;\r\n}\r\n\r\n/* Container with a column direction */\r\n.row-layout {\r\n    display: flex;\r\n    flex-direction: row;\r\n    height: 100%;\r\n}\r\n\r\n/* Container with a column direction */\r\n.column-layout {\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 100%;\r\n}\r\n\r\n/* Item style for empty lists */\r\n.notification-label {\r\n    display: flex;\r\n    justify-content: center;\r\n    padding: 1rem;\r\n    gap: 8px;\r\n}\r\n","@use '/src/custom-style.scss' as *;\r\n\r\n:host {\r\n    @include side-component();\r\n    @include with-shadow();\r\n}\r\n\r\nion-searchbar,\r\nion-progress-bar {\r\n    background-color: var(--ion-background-color);\r\n}\r\n\r\ncdk-tree {\r\n    ion-item {\r\n        display: flex;\r\n\r\n        &:not(.checkbox-item) {\r\n            flex: 1;\r\n        }\r\n\r\n        font-size: var(--font-size-small);\r\n        \r\n    }\r\n}\r\n\r\nion-item.checkbox-item {\r\n    width: auto;\r\n  --min-height: unset;\r\n  --inner-padding-end: 0;\r\n  --inner-padding-start: 0;\r\n  --padding-start: 0;\r\n  --padding-end: 0;\r\n}\r\n\r\n.leaf-wrapper {\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-content: center;\r\n    align-items: center;\r\n    width: 100%;\r\n\r\n    ion-checkbox {\r\n        flex-shrink: 0;\r\n    }\r\n\r\n    ion-item[button] {\r\n        flex: 1;\r\n        min-width: 0;\r\n    }\r\n}\r\n\r\n\r\n.region-searchbar {\r\n    font-size: var(--font-size-medium);\r\n}\r\n\r\n/** Media queries to set font size and spacing based on screen size **/\r\n\r\n/*#region Small Screens*/\r\n\r\n  /* Styles for screens smaller than 800px wide or 550 high */\r\n  @media (max-width: 800px) or (max-height: 550px) {\r\n\r\n    .tree-icon {\r\n        margin-right: 5px;\r\n    }\r\n\r\n  }\r\n/*#endregion Small Screens*/\r\n\r\n/*#region Medium Screens*/\r\n\r\n  /* Styles for medium screens with min with of 800px and min height of 550px */\r\n  @media (min-width: 800px) and (min-height: 550px) {\r\n    .tree-icon {\r\n        margin-right: 10px;\r\n    }\r\n\r\n  }\r\n\r\n/*#endregion Medium Screens*/\r\n\r\n/*#region Larger Screens*/\r\n\r\n  /* Styles for screens larger than 1000px wide and 600px high */\r\n  @media (min-width: 1000px) and (min-height: 600px) {\r\n\r\n  }\r\n\r\n/*#endregion Larger Screens*/\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
